import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import CommandCenter from "./commandCenter/commandCenter";
import SocialWallScreenConfig from "./SocialWallScreen/SocialWallScreenConfig";
import SocialWallScreenSettings from "./SocialWallScreenSettings/SocialWallScreenSettings";
import Highchart from "./Highcharts/HighChart";
import AuthParams from "./Auth/AuthParams";
import SocialWallPersistScreenSettings from "./SocialWallScreenSettings/SocialWallPersistScreenSettings";
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["AuthParams", "SocialWallPersistScreenSettings"],
};
const rootReducer = combineReducers({
  AuthParams: AuthParams,
  SocialWallPersistScreenSettings: SocialWallPersistScreenSettings,
  Highchart,
  CommandCenter,
  SocialWallScreenConfig,
  SocialWallScreenSettings,
});
export default persistReducer(persistConfig, rootReducer);
